// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"93c512f7","339":"91966530","455":"d5d24b04","551":"8c8ed579","640":"00fabdce","828":"7c3a5bc3","842":"d0d9d192","977":"28924b4d"}[chunkId] + ".chunk.js";
};